import { render, staticRenderFns } from "./SocialShareButtons.vue?vue&type=template&id=b84300ac&scoped=true&"
import script from "./SocialShareButtons.vue?vue&type=script&lang=ts&"
export * from "./SocialShareButtons.vue?vue&type=script&lang=ts&"
import style0 from "./SocialShareButtons.vue?vue&type=style&index=0&id=b84300ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84300ac",
  null
  
)

export default component.exports